module.exports = __webpack_public_path__ + "img/Flag_of_Sierra_Leone.7755f12e.svg";